export default __webpack_public_path__ + "497d22626ed5fd3fa40ca455666db0e0.png";